export default {
      id: "icon-social-linkedin-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "icons.svg#icon-social-linkedin",
      toString: function () {
        return this.url;
      }
    }